import React from "react";
import "./DeleteDevice.css";

const DeleteDeviceModal = ({ open, device, onConfirm, onClose, loading = false }) => {
  if (!open || !device) return null;

  return (
    <>
      <div className="delete-device-overlay" onClick={loading ? undefined : onClose} />
      <div
        className="delete-device-popup-container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-device-title"
      >
        <div className="delete-device-header-container">
          <h3 className="delete-device-title" id="delete-device-title">
            Delete device &ldquo;{device.device_name}&rdquo;?
          </h3>
          <button
            className="delete-device-close-button"
            onClick={onClose}
            disabled={loading}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="delete-device-content-container">
          <p className="delete-device-warning">
            This action cannot be undone. The device and its associated data
            will be permanently removed.
          </p>
        </div>
        <div className="delete-device-form-actions">
          <button className="delete-device-cancel-action" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="delete-device-delete-button" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-small" /> Deleting&hellip;
              </>
            ) : (
              "Delete device"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteDeviceModal;
